window.tjs = window.tjs || {};
window.tjs.CookiePrompt = window.tjs.CookiePrompt || {};

// Define common utility functions
(function(){

    /**
     * Create a delegate call for the given object-method combination.
     * @param	Object			Object to act as caller
     * @param	Function		Function to be called
     * @return	Function
     */
    window.delegate = function(obj, method) {
        return function() {
            return method.apply(obj, arguments);
        };
    };

})();


/**
 * Controller for the homepage customer showcase.
 */
window.tjs.CookiePrompt.create = function(_container) {


    var COOKIE_NAME = 'eu-accept-cookies';


    /** @var jQuery Containing element */
    var $myContainer;

    /** @var boolean True, if the prompt is open */
    var amOpen = false;

    this.foo = function() { }

    //console.debug(this, this.foo);


    //-------------------------------------------------------------------------------------


    /**
     * Create a delegate call for the given method.
     * @param	Function		Function to be called
     * @return	Function
     */
    this.delegate = function(method) {

        return window.delegate(this, method);

    };


    //-------------------------------------------------------------------------------------


    /**
     * Returns true if the user has accepted cookies.
     * @param	scalar		No documentation available
     * @return	void
     */
    this.hasAccepted = function() {

        var value = $.cookie(COOKIE_NAME);
        return !!value;

    };


    /**
     * Accept cookies.
     * @return	void
     */
    this.accept = function() {

        if (!this.hasAccepted()) {
            $.cookie(COOKIE_NAME, "1", {
                "expires"	: 365,
                "path"		: "/"
            });
        }

        /*setTimeout(function() {
         $(document).trigger("acceptCookies");
         }, 500);*/

        this.close();

    };


    /**
     * Decline cookies.
     * @return	void
     */
    this.decline = function() {

        this.close();

    };


    /**
     * Open the prompt.
     * @return	void
     */
    this.open = function() {

        if (amOpen) {
            return;
        }

        var height = $myContainer.outerHeight();

        if ($myContainer.filter(':visible').length < 1) {
            $myContainer.show().css("bottom", 0 - height);
        }

        var end = {
            "bottom"	: 0
        };

        $myContainer.stop(true, false).animate(end, 700);

        setTimeout(this.delegate(this.accept), 10000);

        amOpen = true;

    };


    /**
     * Close the prompt.
     * @return	void
     */
    this.close = function() {

        if (!amOpen) {
            return;
        }

        var height = $myContainer.outerHeight();

        var end = {
            "bottom"	: 0 - height
        };

        $myContainer.stop(true, false).animate(end, 480, function() {
            $(this).hide();
        });

        amOpen = false;

    };


    //-------------------------------------------------------------------------------------


    /**
     * Object constructor.
     */
    (function(){

        console.info('Constructing CookiePrompt on', _container);
        $myContainer = $(_container);

    }).call(this);


    /**
     * Object initialiser.
     * @return	void
     */
    this.init = function() {

        console.groupCollapsed('Initialising CookiePrompt...');

        try {

            this.initEvents();

            if (this.hasAccepted()) {
                this.accept();
            }
            else {
                setTimeout(this.delegate(this.open), 1000);
            }

            console.groupEnd();

        }

        catch (err) {
            console.error(err);
            console.groupEnd();
            console.warn('An error was encountered while initialising CookiePrompt');
        }

    };


    /**
     * Initialise events.
     * @return	void
     */
    this.initEvents = function() {

        $myContainer.find(".accept").bind("click", this.delegate(function(event) {
            this.accept();
            event.preventDefault();
        }));

        $myContainer.find(".decline").bind("click", this.delegate(function(event) {
            this.decline();
            event.preventDefault();
        }));

    };

};
